import { d as n } from "../internals/descriptors.js";
import { f as r } from "../internals/function-name.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { d as i } from "../internals/define-built-in-accessor.js";
var s = r.EXISTS,
  o = Function.prototype,
  e = t(o.toString),
  a = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,
  c = t(a.exec);
n && !s && i(o, "name", {
  configurable: !0,
  get: function get() {
    try {
      return c(a, e(this))[1];
    } catch (n) {
      return "";
    }
  }
});